import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Typography,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ClearIcon from "@mui/icons-material/Clear";
import {
  darkTextOverlay,
  invalidAvailabilityBorder,
  invalidAvailability as invalidAvailabilityColor,
  validAvailabilityBorder,
  validAvailability as validAvailabilityColor,
} from "../../../styles/colors";
import { useTranslation } from "react-i18next";

interface AvailabilityCardProps {
  isAvailable?: boolean;
  time: string;
  function?: any;
}

const AvailabilityCard = (props: AvailabilityCardProps) => {
    const { t } = useTranslation();

  return (
    <Card
    sx={{
        height: "220px",
        width: "180px",
        backgroundColor: props.isAvailable
          ? validAvailabilityColor
          : invalidAvailabilityColor,
        borderRadius: "10px",
      }}
      onClick={props.isAvailable ? props.function : null}
    >
      <CardActionArea disabled={props.isAvailable ? false : true}>
        <CardContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            margin: "30px",
            gap: 2,
          }}
        >
          <Box>
            {props.isAvailable ? (
              <CheckCircleIcon
                fontSize="large"
                sx={{ color: darkTextOverlay }}
              />
            ) : (
              <ClearIcon fontSize="large" sx={{ color: darkTextOverlay }} />
            )}
          </Box>
          <Typography
            gutterBottom
            variant="h5"
            fontWeight="bold"
            color={darkTextOverlay}
          >
            {props.time}
          </Typography>
          <Typography
            variant="body2"
            color={
              props.isAvailable
                ? validAvailabilityBorder
                : invalidAvailabilityBorder
            }
            fontWeight="bold"
          >
            {props.isAvailable
                ? t("components.availabilityCard.free")
                : t("components.availabilityCard.busy")}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default AvailabilityCard;
